import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules/index'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    title: 'Primacy Health',
    rowtext: [20, 40, 30, 10, { text: "All", value: -1 }],
    form_rules: {
      required: (value) => !!value || "Required.",
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
    },
    packagetypes: [
      { text: 'Home Visit', value: 'visit' },
      { text: 'Laboratory Tests Request', value: 'lab_request' },
      { text: 'Pharmacy / Drug Delivery', value: 'pharmacy' },
      { text: 'TIKO', value: 'tiko' },
      { text: 'Family Planning', value: 'family_planning' },
      { text: 'Home Based Care', value: 'home_based_care' },
    ],
    icons: {
      help: 'mdi-help-circle',
      create: 'mdi-content-save',
      edit: 'mdi-content-save-edit-outline',
      delete: 'mdi-delete-empty',
      clients: {
        index: 'mdi-account-group'
      }
    },
    popout: 'lorem',
    offline: false,
  },
  getters: {
    rowtext(state) {
      return state.rowtext
    },
    form_rules(state) {
      return state.form_rules
    },
    packagetypes(state) {
      return state.packagetypes
    },
    icons(state) {
      return state.icons
    },
    offline(state) {
      return state.offline
    }
  },
  mutations: {
    setTitle (state, title) {
      state.title = title
    },
    toggleOffline(state, type = null) {
      let now = state.offline
      state.offline = type || !now
    }
  },
  modules,
})

export default store
